
import React, { memo } from 'react';
import { Point3D } from '../types';
import { project } from '../utils/isometricMath';

interface SegmentRendererProps {
  start: Point3D;
  end: Point3D;
  rotation: { x: number, y: number };
  color: string;
}

export const SegmentRenderer: React.FC<SegmentRendererProps> = memo(({ start, end, rotation, color }) => {
  const p1 = project(start, rotation);
  const p2 = project(end, rotation);

  return (
    <line 
      x1={p1.x} y1={p1.y} 
      x2={p2.x} y2={p2.y} 
      stroke={color} 
      strokeWidth="2" 
      strokeLinecap="round" 
    />
  );
});
